// extracted by mini-css-extract-plugin
export default {"list":"CardsList_list__bHF9w"};